import React from 'react';
import { CheckCircle2 } from 'lucide-react';
import { howItWorksSteps } from '../mock';

const HowItWorks = () => {
  return (
    <section id="how-it-works" className="py-24 bg-gradient-to-b from-gray-900 to-black relative overflow-hidden">
      {/* Background decoration */}
      <div className="absolute top-0 left-0 w-96 h-96 bg-purple-600/10 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-purple-800/10 rounded-full blur-3xl"></div>

      <div className="max-w-6xl mx-auto px-6 relative z-10">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-5xl md:text-6xl font-bold text-white mb-4">
            How It <span className="text-purple-400">Works</span>
          </h2>
          <p className="text-xl text-gray-400 max-w-2xl mx-auto">
            Our streamlined process takes you from concept to completion with professional precision
          </p>
          <div className="w-24 h-1 bg-gradient-to-r from-transparent via-purple-500 to-transparent mx-auto mt-6"></div>
        </div>

        {/* Steps */}
        <div className="relative">
          {/* Connecting line */}
          <div className="hidden lg:block absolute top-1/2 left-0 right-0 h-0.5 bg-gradient-to-r from-purple-600/50 via-purple-400/50 to-purple-600/50 transform -translate-y-1/2"></div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {howItWorksSteps.map((step, index) => (
              <div
                key={step.id}
                className="relative"
                style={{ animationDelay: `${index * 150}ms` }}
              >
                {/* Step Card */}
                <div className="bg-gray-900/80 border border-gray-800 rounded-lg p-6 hover:border-purple-500 transition-all duration-300 hover:transform hover:scale-105 relative z-10">
                  {/* Step Number Circle */}
                  <div className="w-16 h-16 bg-gradient-to-br from-purple-600 to-purple-800 rounded-full flex items-center justify-center mb-6 mx-auto shadow-lg shadow-purple-500/50">
                    <span className="text-white font-bold text-2xl">{step.id}</span>
                  </div>

                  {/* Step Label */}
                  <div className="text-center mb-4">
                    <span className="inline-block px-3 py-1 bg-purple-600/20 text-purple-400 text-xs font-mono uppercase rounded-full">
                      {step.step}
                    </span>
                  </div>

                  {/* Content */}
                  <h3 className="text-xl font-bold text-white mb-3 text-center">
                    {step.title}
                  </h3>
                  <p className="text-gray-400 text-center leading-relaxed">
                    {step.description}
                  </p>
                </div>

                {/* Check icon for desktop */}
                {index < howItWorksSteps.length - 1 && (
                  <div className="hidden lg:block absolute top-1/2 -right-4 transform -translate-y-1/2 translate-x-1/2 z-20">
                    <CheckCircle2 className="w-8 h-8 text-purple-500" />
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>

        {/* Bottom CTA */}
        <div className="text-center mt-16">
          <div className="inline-block bg-gray-900/50 border border-purple-500/30 rounded-lg p-8">
            <p className="text-2xl text-white font-bold mb-2">
              Ready to transform your space?
            </p>
            <p className="text-gray-400 mb-6">
              Our vertical wall printer paints directly onto surfaces for a permanent, fade-resistant finish
            </p>
            <a
              href="#contact"
              className="inline-block px-8 py-4 bg-purple-600 text-white rounded-full font-bold text-lg hover:bg-purple-700 transition-all duration-300 hover:scale-105 hover:shadow-lg hover:shadow-purple-500/50"
            >
              Start Your Project
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
